import type { Ref } from "vue"
import { trackHeaderActionClick, trackModuleViewed } from "~/composables/TrackEvents"
import { ApplicationType } from "~/utils/enums/ApplicationType"

export function useHeaderActionTracking(jobData: Ref<FlatJob | null | undefined>) {
  let applicationOverlayTracked = false
  function isExternalApply() {
    return jobData.value?.application_type === ApplicationType.EXTERNAL
  }

  /**
   * Defines the header action label based on the button event and job data.
   *
   * @param event The event object.
   * @returns The header action label.
   */
  function deriveHeaderActionLabel(event: any) {
    if (event && event.source === "pitchYou" && jobData.value && jobData.value.pitch_you_url)
      return "application.whatsapp"

    if (event && event.source === "apply") {
      if (isExternalApply())
        return "application.external"
      return "application.overlay"
    }

    return null
  }

  function onHeaderCtaClick(event: any) {
    const label = deriveHeaderActionLabel(event)
    if (!label)
      return
    if (label === "application.overlay") {
      if (applicationOverlayTracked)
        return
      applicationOverlayTracked = true
    }
    trackHeaderActionClick(label)
  }

  function onFormIntersect(contentModules: any, module: any) {
    trackModuleViewed(contentModules, module)
  }

  return {
    onHeaderCtaClick,
    onFormIntersect,
  }
}
